export default __webpack_public_path__ + "static/media/splatter-no-1.e656eb14.ogg";